export const WEDDING_BUDGET_FORM_ID = "SxhP4j";
export const WEDDING_KIT_FORM_ID = "S9tVmq";
export const KLAVIYO_COMPANY_ID = "HFX6Rc";
export const WEDDING_PLANNING_TEMPLATE_FORM_ID = "UPGczT";

